import 'filepond-polyfill'
import React, { Component } from 'react';
import { authHeader } from '../auth-header';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Paper, LinearProgress, Button } from '@material-ui/core';
import { Link } from 'react-router-dom'
import { FilePond, registerPlugin } from 'react-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import 'filepond/dist/filepond.min.css';
//import { StatResp } from './models';
registerPlugin(FilePondPluginFileValidateType);

const styles = theme => ({
    header: {
        padding: theme.spacing.unit * 2,
    },
    results: {
        margin: theme.spacing.unit * 2,
    },
    errors: {
        padding: theme.spacing.unit * 2,
        color: theme.palette.error.main,
    },
    errorButton: {
        color: theme.palette.error.main,
    },
    pond: {
        height: 180,
    },
    spaceL: { marginLeft: theme.spacing.unit }

});


class SendExport extends Component {
    static displayName = SendExport.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            steps: [],
            stateData: { progress: 0, step: 0 },
        };
        this.fileUploaded = this.fileUploaded.bind(this);
    }

    validate(file, type) {
        return new Promise((resolve, reject) => {
            let ext = file.name.split('.').pop().toLowerCase()
            if (ext === "zip") {
                resolve('application/zip')
            } else {
                reject('Neplatný typ súboru');
            }
        })
    }
    fileUploaded(response) {
        //      console.log(response);
        const status = JSON.parse(response);
        if (status.error.length > 0)
            this.setState({
                steps: ['Overenie súboru pri nahrávaní'],
                loading: false,
                stateData: { resultSummary: status.error, step: 0, progress: 100, success: false, finished: true }
            });
        else
            this.setState({ steps: status.steps, loading: false }, () => this.checkStatus(status.id));
    }
    checkStatus(taskId) {
        fetch('api/UploadExport/GetStatus?id=' + taskId, { headers: authHeader() })
            .then(response => response.json())
            .then(data => {
                //         console.log(data);
                this.setState({ stateData: data });
                if (!data.finished)
                    setTimeout(function () { this.checkStatus(taskId) }.bind(this), 2000);
            })
            .catch(err => {
                setTimeout(function () { this.checkStatus(taskId) }.bind(this), 5000);
            });

    }
    render() {
        const { classes } = this.props;

        return (
            <Paper className={classes.header}>
                <Typography variant="h5" component="h3">Nahrať export</Typography>
                {this.state.loading &&
                    <FilePond
                        className={classes.pond}
                        allowMultiple={false}
                        allowRevert={false}
                        acceptedFileTypes="application/zip, application/x-compressed, application/x-zip-compressed,.zip"
                        fileValidateTypeDetectType={this.validate}
                        labelIdle='Podporované sú iba zip súbory exportu <strong>WReproHD</strong> a <strong>Bioservis</strong><br/><br/>Presuňte súbor sem alebo<span class=" filepond--label-action"> Vyberte súbor </span>'
                        labelFileProcessingComplete='Súbor úspešne nahraný na sever'
                        labelFileProcessing="Prebieha nahrávanie"
                        labelTapToCancel="Prerušiť"
                        labelInvalidField="Neplatný typ súboru"
                        labelFileTypeNotAllowed='Neplatný typ súboru'
                        fileValidateTypeLabelExpectedTypes='Očakávaný formát .zip (wreprohd/bioservis)'
                        labelFileProcessingError='Nastala chyba pri nahrávaní na server'
                        labelTapToRetry='Kliknite sem pre opakovanie'
                        onerror={(err, file, stat) => {
                            console.log('Error on filepond');
                            console.log(err);
                        }}
                        server=
                        {
                            {
                                url: 'api/UploadExport',
                                process: {
                                    headers: authHeader(),
                                    onload: (resp) => {
                                        this.fileUploaded(resp);
                                    }
                                },
                                fetch: null,
                                revert: null
                            }
                        } />
                }
                {this.state.loading !== true && this.state.steps != null && this.state.steps.length > 0 &&
                    <div>
                        <Stepper orientation="vertical" activeStep={this.state.stateData.step}>
                            {
                                this.state.steps.map((msg, idx) => {
                                    const props = {};
                                    if (this.state.stateData.step === idx) {
                                        if (this.state.stateData.finished && !this.state.stateData.success) {
                                            props.error = true;
                                        }
                                        if (!this.state.stateData.finished) {
                                            props.optional = (
                                                <LinearProgress variant="determinate" value={this.state.stateData.progress} />
                                            );
                                        }
                                    }
                                    return (
                                        <Step key={'step' + idx} >
                                            <StepLabel {...props}>{msg}</StepLabel>
                                        </Step>)
                                })

                            }
                        </Stepper>

                        {this.state.stateData.finished === true &&
                            <Typography component="div" variant='body2' className={classes.results}>{this.state.stateData.resultSummary}
                                {this.state.stateData.step > 0 &&
                                    <Button color="secondary" className={classes.spaceL} variant="contained" size="small" component={Link} to='/export-last'>Zobraziť podrobnosti</Button>
                                }
                            </Typography>
                        }
                    </div>
                }
            </Paper>
        );
    }
}
SendExport.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SendExport);



// WEBPACK FOOTER //
// ./src/components/insem/LoadExport.jsx